import React from 'react'
import {  Skeleton, Tabs } from 'antd'
import { FormComponent, BaseFormComponentProps } from '../../BaseComponent'
import { SpecieConsumer } from '../../../context/SpecieContext'

// Tabs
import Settings from './Settings'
import SyncSections from './Sections'
import { SearchRequest } from '../../../services/api/interfaces/ApiRequest'
import IntegrationListTab from './Integrations/page'
import DefinitionsListTab from './Definitions/page'

export type IntegrationFormProps = BaseFormComponentProps & {
  integrationUuid?: string,
  integration?: any | null,

  loading: boolean,
  error: any | null,

  history: any,

  loadIntegration?: (args: SearchRequest) => Promise<any>
}

export default class NetworkForm extends FormComponent<IntegrationFormProps> {

  private readonly TABS = [
    {
      key: 'integrations',
      title: "Integrations",
      Component: IntegrationListTab
    },
    {
      key: 'definitions',
      title: "Definitions",
      Component: DefinitionsListTab
    },
    {
      key: 'sections',
      title: 'Sections',
      Component: SyncSections
    },
    {
      key: 'settings',
      title: 'Settings',
      Component: Settings
    }
  ]

  state = {
    loaded: true,
    currentTab: 'integrations'
  }

  componentDidMount() {
    this.loadList();
  }

  public loadList(){
    const { integrationUuid, loadIntegration } = this.props

    if (integrationUuid && loadIntegration) {
     loadIntegration({
        search: {
          uuid: integrationUuid,
          deleted: false,
          active: true,
          shelter:{
            with : true
          }
        }
      }) 
    } 
  }

  componentDidUpdate(prevProps: IntegrationFormProps, prevState) {
    const wasLoading = !prevProps.integration && this.props.integration
    const newState = Object.assign({}, this.state)
    newState.loaded = true
    if (!this.state.loaded && wasLoading) {
      newState.loaded = true

     // this.setState(newState)
    }
  }

  handleChangeTab = (tab: string) => {
    this.setState({
      currentTab: tab
    })
  }

  render() {
    const { integration } = this.props
    const { loaded, currentTab } = this.state

    if (!loaded) {
      return <Skeleton />
    }
   /*if (!integration?.branch || !integration?.shelter) {
      return (
        <Result
          status="404"
          title="404"
          subTitle="Sorry, this integration is not available anymore."
        />
      )
    } */

    const syncUuid = integration?.integration_syncs && integration.integration_syncs.length > 0 ? integration?.integration_syncs[0].uuid : null

    return (
      <SpecieConsumer>
        {({ fetching, species, requestSpecieList }) => (
          <Tabs activeKey={currentTab} onChange={this.handleChangeTab}>
            {
              this.TABS.map(tab => {
                const { Component }: any = tab
    
                return (
                  <Tabs.TabPane key={tab.key} tab={tab.title}>
                    <Component
                      {...this.props as any}
                      integration={integration}
                      sync_uuid={syncUuid}
                      network_uuid={this.props.integrationUuid}
                      contentLoading={fetching}
                      species={species}
                      loadSpecies={requestSpecieList}
                    />
                  </Tabs.TabPane>
                )
              })
            }
          </Tabs>
        )}
      </SpecieConsumer>
    )
  }
}
